import React, { useEffect, useState } from 'react';
import {
  RouterProvider,
  createBrowserRouter,
  Navigate,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Layout from './hoc/Layout/Layout';
import * as CONSTS from './shared/const/Routes/Routes';
import JobConfiguration from './containers/JobConfiguration/JobConfiguration';
import { getUserData } from './store/actions/userData/userData';
import NotFound from './hoc/NotFound';

import './App.scss';
import { getSafe, isEmpty } from './shared/utility';
import {
  CURRENT_SESSION_JOBS,
  EXTERNAL_WINDOWS,
  USER_DATA,
  USER_PERMISSIONS,
} from './shared/const/Routes/statePaths';
import { getUserPermissions } from './store/actions/userPermissions/userPermissions';
import PermissionManager from './PermissionManager';
import Dashboard from './containers/Dashboard/Dashboard';
import PopupWindow from './components/UI/PopupWindow/PopupWindow';
import { setWindowOpened } from './store/actions/netbatchJobs/netbatchJobs';
import VNCViewer from './containers/Dashboard/VNCViewer/VNCViewer';

const WINDOW_TITLE = 'VNC Viewer - ';

const wrapper = children => (
  <div className="page-layout">
    <PermissionManager>
      <Layout>{children}</Layout>
    </PermissionManager>
  </div>
);

const router = createBrowserRouter([
  {
    path: CONSTS.ROUTES.EMPTY_PATH,
    element: <Navigate to={CONSTS.ROUTES.DASHBOARD} />,
  },
  {
    path: CONSTS.ROUTES.JOB_CONFIGURATION,
    element: wrapper(<JobConfiguration />),
  },
  {
    path: CONSTS.ROUTES.DASHBOARD,
    element: wrapper(<Dashboard />),
  },
  {
    path: CONSTS.ROUTES.FARM_REPOSITORY,
    element: wrapper(<NotFound />),
  },
  {
    path: CONSTS.ROUTES.RELEASE_PACKAGE,
    element: wrapper(<NotFound />),
  },
  {
    path: CONSTS.ROUTES.UPLOAD_INGREDIENT,
    element: wrapper(<NotFound />),
  },
  {
    path: CONSTS.ROUTES.VNC_VIEWER,
    element: wrapper(<NotFound />),
  },
]);

const App = () => {
  const dispatch = useDispatch();

  const [openWindows, setOpenWindows] = useState([]);

  const userData = useSelector(state => getSafe(USER_DATA, state));
  const vncNBJobs = useSelector(state => getSafe(CURRENT_SESSION_JOBS, state));
  const externalWindows = useSelector(state =>
    getSafe(EXTERNAL_WINDOWS, state)
  );
  const userPermissions = useSelector(state =>
    getSafe(USER_PERMISSIONS, state)
  );

  useEffect(() => {
    dispatch(getUserData());
  }, []);

  useEffect(() => {
    if (!!userData && !!userData.idsid) {
      dispatch(getUserPermissions(userData.idsid));
    }
  }, [userData]);

  useEffect(() => {
    Object.keys(vncNBJobs).forEach(jobId => {
      let job = vncNBJobs[jobId];
      if (job !== undefined && job.shouldOpenWindow) {
        dispatch(setWindowOpened(job));
        setOpenWindows(prevOpenWindows => {
          const arr = [...prevOpenWindows, openNewWindow(job)];
          const filtered = arr
            .reverse()
            .filter(
              (ele, ind, self) => ind === self.findIndex(e => e.key === ele.key)
            )
            .reverse();
          return filtered;
        });
      }
    });
  }, [vncNBJobs]);

  useEffect(() => {
    const windowElements = openWindows.filter(win => externalWindows[win.key]);
    setOpenWindows(windowElements);
  }, [externalWindows]);

  const openNewWindow = job => {
    return (
      <div key={job.Jobid}>
        <PopupWindow
          title={WINDOW_TITLE + job.epc_vncserver_display}
          width="1900"
          height="1220"
          left="50"
          top="50"
          job={job}
        >
          <VNCViewer job={job}></VNCViewer>
        </PopupWindow>
      </div>
    );
  };

  return !isEmpty(userData) && !isEmpty(userPermissions) ? (
    <>
      <RouterProvider router={router} />
      {openWindows.length > 0 && React.Children.toArray(openWindows)}
    </>
  ) : null;
};
export default App;
